import { EncounterActions, EncounterTimerContextInterface } from "../initialState/EncounterTimer";

export const ENCOUNTER_TIMER_DISPATCHES = {
  startEncounter: "START_ENCOUNTER",
  updateEncounterTimer: "UPDATE_ENCOUNTER_TIMER",
  pauseEncounterTimer: "PAUSE_ENCOUNTER_TIMER",
  unpauseEncounterTimer: "UNPAUSE_ENCOUNTER_TIMER",
  resetEncounterTimer: "RESET_ENCOUNTER_TIMER",

};

function encounterTimerReducer(
  state: EncounterTimerContextInterface,
  { type, payload }: { type: string; payload: any }
): EncounterTimerContextInterface {
  switch (type) {
    case ENCOUNTER_TIMER_DISPATCHES.startEncounter:
      return {
        ...state,
        current: payload.current
      };
    case ENCOUNTER_TIMER_DISPATCHES.updateEncounterTimer:
      if (!state.current) return state;
      return {
        ...state,
        current: {
          ...state.current,
          duration: payload.duration ?? state.current.duration,
          escalatedDuration: payload.escalatedDuration ?? state.current.escalatedDuration
        }
      };
    case ENCOUNTER_TIMER_DISPATCHES.pauseEncounterTimer:
      if (!state.current) return state;
      return {
        ...state,
        current: {
          ...state.current,
          pause: true,
        },
      };
    case ENCOUNTER_TIMER_DISPATCHES.unpauseEncounterTimer:
      if (!state.current) return state;
      return {
        ...state,
        current: {
          ...state.current,
          pause: false,
        },
      };
    case ENCOUNTER_TIMER_DISPATCHES.resetEncounterTimer:
      return {
        ...state,
        current: {
          memberId: "",
          actions: [],
          duration: 0,
          escalatedDuration: 0,
          pause: true,
        },
      };
    default:
      return state;
  }
}

export default encounterTimerReducer;